import { programBoardDetail } from '@/network/apis/apiUri';

const processingIncrease = new Set();

export const increaseDetailHitCount = async (boardItemId) => {
  if (processingIncrease.has(boardItemId)) return;

  processingIncrease.add(boardItemId);
  try {
    await programBoardDetail({ board_item_id: boardItemId, hit: true });
  } catch (e) {
    // console.error(e)
  } finally {
    processingIncrease.delete(boardItemId);
  }
};
